import * as routes from '../../../routes/const';

//Have local definition of route , once the acl hardcoding of the route has been resolved - sri -TODO
export const DASHBOARD_PROFILE = routes.DASHBOARD_PROFILE;
export const DASHBOARD_PROFILE_ID = routes.DASHBOARD_PROFILE_ID;



// WEBPACK FOOTER //
// ./src/features/dashboard/routes/const.js